var _g, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailSuccessIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 81,
    viewBox: "0 0 100 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_600_15344)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9827 23.8105H68.0173C72.2562 23.8105 76.3214 25.4753 79.3188 28.4385C82.3161 31.4017 84 35.4206 84 39.6112V68.1008H0V39.6112C0 35.4206 1.68389 31.4017 4.68122 28.4385C7.67856 25.4753 11.7438 23.8105 15.9827 23.8105V23.8105Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9828 25.2917H68.0175C71.859 25.2917 75.5431 26.8004 78.2594 29.4858C80.9758 32.1712 82.5018 35.8134 82.5018 39.6111V66.6194H1.49854V39.6111C1.49854 35.8134 3.02456 32.1712 5.74089 29.4858C8.45723 26.8004 12.1414 25.2917 15.9828 25.2917V25.2917Z",
    stroke: "#1E1E1E",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9827 23.8105H20.7675C25.0064 23.8105 29.0716 25.4753 32.069 28.4385C35.0663 31.4017 36.7502 35.4206 36.7502 39.6112V68.1008H0V39.6112C0 35.4206 1.68389 31.4017 4.68122 28.4385C7.67856 25.4753 11.7438 23.8105 15.9827 23.8105V23.8105Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9828 25.2917H20.7677C24.6091 25.2917 28.2933 26.8004 31.0096 29.4858C33.726 32.1712 35.252 35.8134 35.252 39.6111V66.6194H1.49854V39.6111C1.49854 35.8134 3.02456 32.1712 5.74089 29.4858C8.45723 26.8004 12.1414 25.2917 15.9828 25.2917V25.2917Z",
    stroke: "#1E1E1E",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.1001 33.4688H57.7503",
    stroke: "#1E1E1E",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8448 18.457L66.2372 10.9645L50.9248 3V33.9871",
    fill: "#3FCC3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8448 18.457L66.2372 10.9645L50.9248 3V33.9871",
    stroke: "#1E1E1E",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5146 66.731V77.0656H55.452V66.731",
    stroke: "#1E1E1E",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3426 48.5574V43.353H9.66064V48.5574H27.8409",
    fill: "#FFE54A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3426 48.5574V43.353H9.66064V48.5574H27.8409",
    stroke: "#1E1E1E",
    strokeWidth: 3
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M95.6668 63.9999C95.6668 70.9955 89.9958 76.6666 83.0002 76.6666C76.0046 76.6666 70.3335 70.9955 70.3335 63.9999C70.3335 57.0043 76.0046 51.3333 83.0002 51.3333C89.9958 51.3333 95.6668 57.0043 95.6668 63.9999Z",
    fill: "#5ECC61",
    stroke: "#1E1E1E",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M88.6067 58.6875L81.0715 66.1417L77.9928 62.9357L75.917 65.0913L81.1239 70.4232L90.7338 60.8122L88.6067 58.6875Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_600_15344"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 84,
    height: 78,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailSuccessIcon);
export default __webpack_public_path__ + "static/media/EmailSuccessIcon.11a363aa3f99b68815634f9bbecf673c.svg";
export { ForwardRef as ReactComponent };